/**
 * What a meeting attachment may be — a file the user puts into the meeting
 * page's rich text editor. Shared so the editor's picker, its pre-upload
 * checks and the backend validation state each rule exactly once.
 */

export const MEETING_ATTACHMENT_IMAGE_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
] as const;

export type MeetingAttachmentImageMime =
  (typeof MEETING_ATTACHMENT_IMAGE_MIME_TYPES)[number];

export const MEETING_ATTACHMENT_FILE_MIME_TYPES = [
  'application/pdf',
  'text/plain',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
] as const;

export type MeetingAttachmentFileMime =
  (typeof MEETING_ATTACHMENT_FILE_MIME_TYPES)[number];

/** Pasted images larger than this are rejected. */
export const MAX_MEETING_ATTACHMENT_IMAGE_BYTES = 5 * 1024 * 1024;

/** Attached files larger than this are rejected. */
export const MAX_MEETING_ATTACHMENT_FILE_BYTES = 10 * 1024 * 1024;

/**
 * One attachment, as the editor holds it: `kind` decides whether it renders
 * inline or as a download chip, and `url` is the auth-proxied address the
 * document embeds. The storage key never leaves the backend.
 */
export interface MeetingAttachmentResponse {
  id: string;
  kind: 'image' | 'file';
  mime: string;
  name: string;
  size: number;
  url: string;
}
